import React, { Component } from 'react';

const defaultOnSurfaceActivityTimeoutMs = 5000;
const defaultOffSurfaceActivityTimeoutMs = 500;

// This component is used as parent component and measures if the user has performed activity within the childs components within the provided activity time-out period.
// Activity is when the user has moved its mouse, pushsed a button or scrolled the contents. The following props need to be provided:
// - onActivityStateChange: Invoked on every change of the user activity state.
// - activityTimeoutMs: The number of milliseconds to wait before the user is considered to be inactive.
// - initialIsActive: The initial 'isActive' state of this component.
export class ActivityMeasurement extends Component {
    constructor(props) {
        super(props);

        this.timerId = 0;
        this.isActive = props.initialIsActive;
        this.isOnSurface = false;     
        this.onSurfaceActivityTimeoutMs = props.onSurfaceActivityTimeoutMs || defaultOnSurfaceActivityTimeoutMs;
        this.offSurfaceActivityTimeoutMs = props.offSurfaceActivityTimeoutMs || defaultOffSurfaceActivityTimeoutMs;
        this.isUnmounted = false;
    }

    componentDidMount() {
        if (this.props.initialIsActive) {
            // Ensure the time-out timer is started when the initial state is active.
            this.handleUserActivity();
        }                
    }

    componentWillUnmount() {
        clearTimeout(this.timerId);
        this.isUnmounted = true;
    }

    handleUserActivity = () => {
        clearTimeout(this.timerId);
        
        this.reportActivityStateChange(true);
        
        const timeout = this.isOnSurface ? this.onSurfaceActivityTimeoutMs : this.offSurfaceActivityTimeoutMs;        

        this.timerId = setTimeout(() => {
            this.reportActivityStateChange(false);
        }, timeout);
    }

    handleMouseEnter = () => {
        this.isOnSurface = true;
        this.handleUserActivity();
    }

    handleMouseLeave = () => {
        this.isOnSurface = false;
        this.handleUserActivity();
    }

    reportActivityStateChange = (newIsActiveState) => {
        if (newIsActiveState !== this.isActive && !this.isUnmounted) {
            if (this.props.onActivityStateChange) {
                this.props.onActivityStateChange(newIsActiveState);
            }

            this.isActive = newIsActiveState;
        }
    }

    render() {
        return (
            <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} onTouchMove={this.handleUserActivity} onMouseMove={this.handleUserActivity} onScroll={this.handleUserActivity} onKeyDown={this.handleUserActivity} >
                {this.props.children}
            </div>
        )      
    }
}
